import CasesFooter from "./CasesFooter";

export default CasesFooter;
